import { Routes, Route, useLocation } from 'react-router-dom'
import { AnimatePresence, motion } from 'framer-motion'
import { ChatProvider } from './context/ChatContext.jsx'
import { ThemeProvider } from './context/ThemeContext.jsx'
import { DataProvider } from './context/DataContext.jsx'
import { AboutSiteProvider } from './context/AboutSiteContext.jsx'
import { useChatActions } from './hooks/useChatActions.js'
import Chrome from './components/Chrome.jsx'
import HomePage from './pages/HomePage.jsx'
import ExperiencePage from './pages/ExperiencePage.jsx'
import EducationPage from './pages/EducationPage.jsx'
import ProjectsPage from './pages/ProjectsPage.jsx'
import ProjectDetailPage from './pages/ProjectDetailPage.jsx'
import BlogListPage from './pages/BlogListPage.jsx'
import BlogDetailPage from './pages/BlogDetailPage.jsx'
import ResumePage from './pages/ResumePage.jsx'
import SkillsPage from './pages/SkillsPage.jsx'
import ContactPage from './pages/ContactPage.jsx'
import StatsPage from './pages/StatsPage.jsx'
import NotFoundPage from './pages/NotFoundPage.jsx'

const pageVariants = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -12 },
}

const pageTransition = {
  duration: 0.25,
  ease: [0.25, 0.1, 0.25, 1],
}

function AppRoutes() {
  const location = useLocation()
  useChatActions()

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial="initial"
        animate="animate"
        exit="exit"
        variants={pageVariants}
        transition={pageTransition}
        className="w-full"
      >
        <Routes location={location}>
          <Route path="/" element={<HomePage />} />
          <Route path="/experience" element={<ExperiencePage />} />
          <Route path="/education" element={<EducationPage />} />
          <Route path="/skills" element={<SkillsPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/projects/:slug" element={<ProjectDetailPage />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogDetailPage />} />
          <Route path="/resume" element={<ResumePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/stats" element={<StatsPage />} />
          <Route path="*" element={<NotFoundPage />} />
          <Route path="/admin" />
        </Routes>
      </motion.div>
    </AnimatePresence>
  )
}

function App() {
  return (
    <ThemeProvider>
      <DataProvider>
        <ChatProvider>
          <AboutSiteProvider>
            <Chrome>
              <AppRoutes />
            </Chrome>
          </AboutSiteProvider>
        </ChatProvider>
      </DataProvider>
    </ThemeProvider>
  )
}

export default App
